
import { FC, useRef, useEffect } from "react";
import { useStore, connect } from 'src/store/connect';
import { makeStyles, Theme } from "@material-ui/core/styles";
import { scrollToBottom } from './utils'
import format from 'date-fns/format';
import Message from './Message';

interface MessagesProps { };

const Messages: FC<MessagesProps> = () => {
    const classes = useStyles();
    const state = useStore();
    const messageRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
      scrollToBottom(messageRef.current);
    }, [state.messages]);

    return (
      <div className={classes.root} ref={messageRef}>
        {state.messages?.map((message: Message, index: number) =>
          <div key={`${index}-${format(message.timestamp, 'hh:mm')}`}>
            <Message message={message} />
          </div>
        )}
      </div>
    );
};

Messages.defaultProps = { };

export default connect(Messages)

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: "#e5ddd6",
    height: "calc(100% - 50px - 130px)",
    overflowY: "scroll",
    padding: "10px 0",
    margin: "0 0 10px 0",
  }
}));
